import { FC } from 'react';
import cn from 'bem-cn';

import goldenWreath from '../../../../images/icons/wreath_gold.svg';
import silverWreath from '../../../../images/icons/wreath_silver.svg';
import bronzeWreath from '../../../../images/icons/wreath_bronze.svg';
import paperWreath from '../../../../images/icons/wreath_paper.svg';

import { ImageWithFadeIn } from '../../../UI';

import { RankProps, RankType } from './Rank.types';
import { getMilestone } from './Rank.helpers';
import './Rank.scss';

const b = cn('rank');

export const Rank: FC<RankProps> = ({ rank }) => {
    const type =
        {
            '1': RankType.Gold,
            '2': RankType.Silver,
            '3': RankType.Bronze,
        }[rank] || RankType.Paper;

    const milestone = getMilestone(rank);

    const typeToWreath = {
        gold: goldenWreath,
        silver: silverWreath,
        bronze: bronzeWreath,
        paper: paperWreath,
    };

    if (Number(rank) > 100) {
        return (
            <div className={b({ 'only-number': true })}>
                <span className={b('number')}>{rank}</span>
            </div>
        );
    }

    return (
        <div className={b({ type })}>
            {type && <ImageWithFadeIn src={typeToWreath[type]} alt="" className={b('wreath')} />}
            <span className={b('number')}>{rank}</span>
            <span className={b('text')}>ТОП {milestone}</span>
        </div>
    );
};
